import CityPageTemplate from "../city-template/CityPageTemplate";
import { ketteringConfig } from "./data";

export default function KetteringPage() {
  return <CityPageTemplate config={ketteringConfig} />;
}